<button mat-button routerLink="/">
  <mat-icon>arrow_back_ios</mat-icon>
  Tillbaka
</button>
<mat-card>
  <mat-card-title>{{ (item | async)?.title }}</mat-card-title>
  <mat-card-content>{{ (item | async)?.body }}</mat-card-content>
</mat-card>
